import { ReactElement } from 'react'

export const RecurringInvoicesTableActions = (): ReactElement => <></>
